mutation createTopic($input: CreateTopicInput!) {
  topic: createTopic(input: $input) {
    id
    name
    description
    status
    isSystemGenerated
    isUserEditable
    landingpage {
      id
      slug
    }
  }
}
